import { IStore } from '../ducks/stores';

/**
 * Nearby results can drop restaurants that violate an offer restriction.
 * The restaurant already selected must stay in the picker when the guest
 * opened it from the unavailable card, so it can render as the grey,
 * non-selectable row. Eligibility, not this visibility helper, disables it.
 */
export function resolveVisibleActiveStore({
  activeStore,
  pinCurrentAsUnavailable,
  storeFilter,
}: {
  activeStore: IStore | null;
  pinCurrentAsUnavailable: boolean;
  storeFilter?: (store: IStore) => boolean;
}): IStore | null {
  if (!activeStore) {
    return null;
  }

  if (pinCurrentAsUnavailable || !storeFilter || storeFilter(activeStore)) {
    return activeStore;
  }

  return null;
}
